let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jdXR8")).then(() => parcelRequire('cW0LW'));